'use client';

import a__default, { memo, useRef } from "react";
import { classNames } from "../../utils/styles/classNames.js";
import { Text } from "../../atoms/Text/Text.js";
import { useIsStuck } from "../../utils/hooks/useIsStuck.js";
import { Badge } from "../../atoms/Badge/Badge.js";
import { headerState, headerStick, variants, headerWrapper, header, status, tab, buttonStatus, buttonCursor, buttonVariant, button } from "../Tabs/Tabs.css.js";
import { getTextColor } from "../Tabs/utils/getTextColor.js";
import { CustomAnchor } from "../../quarks/CustomAnchor/CustomAnchor.js";
import { defaultCounterLabel } from "./TabNav.data.js";
function TabNavComponent({
  tabs,
  variant: variantProp,
  sticky,
  currentTabId
}) {
  const variant = variantProp || "primary";
  const isSticky = sticky;
  const headerRef = useRef(null);
  const isStuck = useIsStuck(headerRef, isSticky);
  return /* @__PURE__ */ a__default.createElement(
    "nav",
    {
      className: classNames(
        headerWrapper,
        variants[variant],
        isSticky && headerStick,
        isSticky && headerState[isStuck ? "stuck" : "default"]
      ),
      ref: headerRef
    },
    /* @__PURE__ */ a__default.createElement("ul", { className: classNames(header) }, tabs && tabs.map((tab$1) => {
      const active = !tab$1.disabled && tab$1.id === currentTabId;
      const textColor = getTextColor(active, tab$1.disabled);
      const defaultStatus = active ? "active" : "default";
      const status$1 = tab$1.disabled ? "disabled" : defaultStatus;
      const Icon = tab$1.icon;
      const iconJsx = Icon && /* @__PURE__ */ a__default.createElement(Icon, { filled: tab$1.iconStyle === "filled", size: "sm" });
      const isLink = !!tab$1.href;
      const Element = isLink ? CustomAnchor : "button";
      const counterLabel = tab$1.counter && `${tab$1.counter} ${tab$1.a11yCounterLabel ?? defaultCounterLabel(tab$1.counter)}`;
      return /* @__PURE__ */ a__default.createElement(
        "li",
        {
          className: classNames(tab, status[status$1]),
          key: tab$1.id
        },
        /* @__PURE__ */ a__default.createElement(
          Element,
          {
            "aria-current": active ? true : void 0,
            "aria-disabled": !isLink && tab$1.disabled ? true : void 0,
            className: classNames(
              button,
              !tab$1.disabled && buttonVariant[variant === "secondary" ? "secondary" : "primary"],
              buttonCursor[tab$1.disabled ? "disabled" : "default"],
              buttonStatus[status$1]
            ),
            href: isLink ? tab$1.href : void 0,
            role: !isLink ? "link" : void 0,
            type: !isLink ? "button" : void 0,
            onClick: !isLink && !tab$1.disabled ? tab$1.onClick : void 0
          },
          iconJsx,
          tab$1.a11yLabel && /* @__PURE__ */ a__default.createElement(Text, { visuallyHidden: true }, tab$1.a11yLabel),
          /* @__PURE__ */ a__default.createElement(
            Text,
            {
              "aria-hidden": tab$1.a11yLabel ? "true" : void 0,
              as: "span",
              color: textColor,
              variant: "label.sm"
            },
            tab$1.label
          ),
          tab$1.counter && counterLabel && /* @__PURE__ */ a__default.createElement(
            Badge,
            {
              a11yLabel: counterLabel,
              emphasis: variant === "primary" ? "medium" : "high",
              label: `${tab$1.counter}`,
              roundness: "full",
              variant: variant === "primary" ? "primary" : "neutral"
            }
          )
        )
      );
    }))
  );
}
const TabNav = /* @__PURE__ */ memo(TabNavComponent);
export {
  TabNav
};
